export const getJson = async <T>(path: string) => {
  return fetch(path).then(response => {
    return response.json() as T;
  });
};